import React, { useEffect } from "react";
import { useGetAIAgents } from "hooks/useGetAIAgents";
import { AgentCard } from "../components/AgentCard/AgentCard";
import { IAgent } from "interfaces/entities/agent.interface";
import { Button, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setDataAction } from "redux/actions/agentsActions";
import PageGuide from "components/PageGuide/PageGuide";
import { BotVsAgentTable, ReplyOrder } from "components/ReplyModes/ReplyModes";

export const AgentList = () => {
  const { data, isLoading, error } = useGetAIAgents();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDataAction(data?.rows));
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <h1>ИИ-агенты</h1>
      <p className="text-gray-600 mb-4">
        ИИ-агент отвечает клиентам своими словами 24/7, опираясь на промпт и базу знаний о вашей компании.
        Чтобы агент отвечал в мессенджере, подключите его к каналу.
      </p>
      <PageGuide id="bot-vs-agent-agents" title="ИИ-агент или чат-бот — в чём разница?">
        <div className="flex flex-col gap-4">
          <BotVsAgentTable />
          <ReplyOrder />
        </div>
      </PageGuide>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        <Card>
          <div className="flex justify-center items-center w-full h-full">
            <div className="flex justify-center items-center">
              <Button
                variant="text"
                color="primary"
                onClick={() => navigate("/admin/ai-agents/add")}
              >
                Создать агента <FaPlus className="ml-4" />
              </Button>
            </div>
          </div>
        </Card>
        {data.rows.map((agent: IAgent) => (
          <AgentCard key={agent.id} agent={agent} />
        ))}
      </div>
    </div>
  );
};
